/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} CrosspostingInputs */

const en_crossposting = /** @type {(inputs: CrosspostingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Crossposting`)
};

const de_crossposting = /** @type {(inputs: CrosspostingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gleichzeitig posten`)
};

/**
* | output |
* | --- |
* | "Crossposting" |
*
* @param {CrosspostingInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const crossposting = /** @type {((inputs?: CrosspostingInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<CrosspostingInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_crossposting(inputs)
	return de_crossposting(inputs)
});